import React from "react";
import { SectionHeader } from "./ui/SectionHeader";
import { Button } from "./ui/Button";
import { Settings, Cog, Droplet, CircleDot, Gauge, Search, Eye, ShieldCheck, Wrench, BookOpen } from "lucide-react";
export function WhatYouWillLearn() {
  const learningPoints = [{
    text: "Conceptos fundamentales de mecánica industrial",
    icon: Settings
  }, {
    text: "Funcionamiento de máquinas y componentes",
    icon: Cog
  }, {
    text: "Sistemas de transmisión y lubricación",
    icon: Droplet
  }, {
    text: "Rodamientos, soportes, ejes y acoplamientos",
    icon: CircleDot
  }, {
    text: "Hidráulica y neumática",
    icon: Gauge
  }, {
    text: "Diagnóstico de fallas",
    icon: Search
  }, {
    text: "Inspección de correas, poleas, cadenas y reductores",
    icon: Eye
  }, {
    text: "Mantenimiento preventivo",
    icon: ShieldCheck
  }, {
    text: "Técnicas aplicadas al mantenimiento industrial",
    icon: Wrench
  }, {
    text: "Lectura de planos y manuales técnicos",
    icon: BookOpen
  }];
  return <section className="w-full bg-white py-10 md:py-16" data-id="element-294" data-mp="3aeexxmdyc3b">
      <div className="container mx-auto px-4 md:px-6 max-w-[1120px]" data-id="element-295" data-mp="3ufe8pjyqrmys">
        <SectionHeader badge="CONTENIDO" theme="light" title={<>¿QUÉ VAS A <span className="text-[#F3AD00]" data-id="element-297" data-mp="3pgt7pibo0z9a">APRENDER?</span></>} subtitle="Un recorrido completo por las áreas clave que todo profesional del mantenimiento debe dominar." className="mb-6 md:mb-10" data-id="element-296" data-mp="3uhh5qnybagd0" />

        <div className="bg-[#F5F7F9] rounded-[20px] p-4 md:p-6 shadow-sm border border-gray-100 max-w-4xl mx-auto mb-8 md:mb-10" data-id="element-298" data-mp="lxzwhc6d0mia">
          <div className="grid grid-cols-2 gap-3 md:gap-5" data-id="element-299" data-mp="h2b0fitjtnqq">
            {learningPoints.map((point, idx) => {
            const Icon = point.icon;
            return <div key={idx} className="flex flex-col sm:flex-row items-center sm:items-start gap-2 sm:gap-3 bg-white p-3 md:p-4 rounded-xl shadow-sm border border-gray-50 text-center sm:text-left" data-id="element-300" data-mp="86v2aplrgmfc" data-mpi={idx}>
                  <div className="bg-[#142FA8]/10 p-2 rounded-lg flex-shrink-0" data-id="element-301" data-mp="zy16pi8il6af">
                    <Icon className="w-5 h-5 md:w-6 md:h-6 text-[#142FA8]" data-id="element-302" data-mp="2u6ei38tb469e" />
                  </div>
                  <span className="text-[12px] sm:text-[14px] md:text-[15px] text-[#07152D] font-[600] leading-tight mt-1 sm:mt-0.5" data-id="element-303" data-mp="2z6kawsbbbyt2">{point.text}</span>
                </div>;
          })}
          </div>
        </div>

        <div className="flex justify-center" data-id="element-304" data-mp="2pfg1070hv453">
          <Button size="xl" className="w-[90%] sm:w-[95%] max-w-[350px]" data-id="element-305" data-mp="2pe4sxv00na86">
            QUIERO ASEGURAR MI ACCESO <span className="ml-2 font-bold text-lg" data-id="element-306" data-mp="2bij69uh992ix">→</span>
          </Button>
        </div>
      </div>
    </section>;
}